import { IItemOrcamento } from "app/types/IItemOrcamento";
import { RespostaConsultaItensOrcamento } from "app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento";

export const dadosOrcamentoParaTeste : RespostaConsultaItensOrcamento = {
  "Itens": [
    {
      "AdquirirQuantidadeTotal": false,
      "ProdutoEncomendaComprarTotal": false,
      "AliquotaIpi": 0.0,
      "Ambiente": "",
      "Carga": "A",
      "Classe": "Itempedidovenda",
      "Codigo": "93962",
      "CodigoCorTinta": "0",
      "CodigoFilialReserva": "09",
      "CodigoFilialRetirada": "FR 04",
      "CodigoFilialTransferencia": "FT 04",
      "CodigoItemOrcamento": 0,
      "CodigoProduto": "93962",
      "CodigoTinta": 0,
      "CodigoTipoEntrega": "F",
      "ControleLote": false,
      "Cor": "#000000",
      "DataMarcadaEntrega": null,
      "DataPrevisaoEntrega": "2022-05-07T00:00:00",
      "DescontoMaximo": 0.0,
      "DescontoPendente": false,
      "PrecoAlteradoManualmente": false,
      "DescricaoProduto": "CADERNO 1/4 PROFISSIONAL 72 FLS - 45814 - OXFORD",
      "DespesasInclusas": false,
      "EncomendaAutomatica": false,
      "EntregaPosterior": 0,
      "Identificador": 1330613,
      "Index": 1,
      "Lote": "",
      "MenorFracaoVenda": 1.0,
      "NfDevolucao": "",
      "PedidoCompraCliente": 1,
      "Pendencia": "",
      "PercentualDesconto": 0.0,
      "PermiteAlterarPreco": true,
      "Peso": 0.385,
      "PrecoProduto": 59.0,
      "PrecoTinta": 0.0,
      "PrecoTotalAVista": 59.0,
      "PrecoTotalTabela": 59.0,
      "PrecoAVista": 59.0,
      "PrecoUnitarioAVista": 59.0,
      "PrecoUnitarioTabela": 59.0,
      "Quantidade": 1.0,
      "QuantidadeFormatada": null,
      "QuantidadeDevolvida": 0.0,
      "QuantidadeEstoque": 97.0,
      "QuantidadeReservada": 0.0,
      "TipoFaturamento": null,
      "TipoVendaSobEncomenda": 0,
      "TurnoEntrega": null,
      "Unidade": "PC",
      "ValorDesconto": 0.0,
      "ValorIpi": 0.0,
      "ValorSubstituicao": 0.0,
      "ValorTotal": 59.0,
      "VendaSobEncomenda": false,
      "Volume": 1,
      "PendenciaLocalRetirada": false,
      "IdClienteCentroCusto": 0,
      "NomeCentroCusto": "",
      "PedidoCompra": "pedido compra A",
      "PercentualMarkUp": 45.64,
      "MarkUpAbaixoDoPermitido": false,
      "MarkupMinimo": 20.0,
      "PrecoVendaMinimoCustoReal": 26.0360571428571,
      "OrdemItem": 1,
      "ListEstoqueProduto": {
        "Codigo": "93962",
        "CodigoProduto": "93962",
        "Descricao": "CADERNO 1/4 PROFISSIONAL 72 FLS - 45814 - OXFORD",
        "Estoques": [
          {
            "CodigoFilial": "09",
            "Quantidade": 100.0,
            "QuantidadeReservada": 3.0,
            "QuantidadePedida": 1.0,
            "QuantidadeDisponivel": 97.0,
            "QuantidadeDiferenca": -96.0,
            "QuantidadePedidoFornecedor": 3.0
          },
          {
            "CodigoFilial": "01",
            "Quantidade": 100.0,
            "QuantidadeReservada": 18.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 82.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 1.0
          },
          {
            "CodigoFilial": "02",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "03",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 1.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259699.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "04",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 4.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259696.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "05",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "06",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "07",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "08",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "98",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "99",
            "Quantidade": 0.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 0.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          }
        ],
        "UserMessage": null
      },
      "DesativaRegimeEspecial": null,
      "BloquearRegimeEspecial": false,
      "DesativaRegimeEspecialAntes": null,
      "PendenciaDescontoSobreOferta": false,
      "UserMessage": null,
      "ServicoAgregado": false
    },
    {
      "AdquirirQuantidadeTotal": false,
      "ProdutoEncomendaComprarTotal": false,
      "AliquotaIpi": 0.0,
      "Ambiente": "",
      "Carga": "A",
      "Classe": "Itempedidovenda",
      "Codigo": "93961",
      "CodigoCorTinta": "0",
      "CodigoFilialReserva": "09",
      "CodigoFilialRetirada": "FR 01",
      "CodigoFilialTransferencia": "FT 01",
      "CodigoItemOrcamento": 0,
      "CodigoProduto": "93961",
      "CodigoTinta": 0,
      "CodigoTipoEntrega": "F",
      "ControleLote": false,
      "Cor": "#000000",
      "DataMarcadaEntrega": null,
      "DataPrevisaoEntrega": "2022-05-07T00:00:00",
      "DescontoMaximo": 0.0,
      "DescontoPendente": false,
      "PrecoAlteradoManualmente": false,
      "DescricaoProduto": "Caderno 1/4 profissional 72 folhas 45812 - Oxford",
      "DespesasInclusas": false,
      "EncomendaAutomatica": false,
      "EntregaPosterior": 0,
      "Identificador": 454814,
      "Index": 2,
      "Lote": "",
      "MenorFracaoVenda": 1.0,
      "NfDevolucao": "",
      "PedidoCompraCliente": 2,
      "Pendencia": "",
      "PercentualDesconto": 0.0,
      "PermiteAlterarPreco": true,
      "Peso": 0.38,
      "PrecoProduto": 59.0,
      "PrecoTinta": 0.0,
      "PrecoTotalAVista": 59.0,
      "PrecoTotalTabela": 59.0,
      "PrecoAVista": 59.0,
      "PrecoUnitarioAVista": 59.0,
      "PrecoUnitarioTabela": 59.0,
      "Quantidade": 1.0,
      "QuantidadeFormatada": null,
      "QuantidadeDevolvida": 0.0,
      "QuantidadeEstoque": 99.0,
      "QuantidadeReservada": 0.0,
      "TipoFaturamento": null,
      "TipoVendaSobEncomenda": 0,
      "TurnoEntrega": null,
      "Unidade": "PC",
      "ValorDesconto": 0.0,
      "ValorIpi": 0.0,
      "ValorSubstituicao": 0.0,
      "ValorTotal": 59.0,
      "VendaSobEncomenda": false,
      "Volume": 1,
      "PendenciaLocalRetirada": false,
      "IdClienteCentroCusto": 0,
      "NomeCentroCusto": "",
      "PedidoCompra": "pedido compra B",
      "PercentualMarkUp": 45.64,
      "MarkUpAbaixoDoPermitido": false,
      "MarkupMinimo": 20.0,
      "PrecoVendaMinimoCustoReal": 26.0360571428571,
      "OrdemItem": 2,
      "ListEstoqueProduto": {
        "Codigo": "93961",
        "CodigoProduto": "93961",
        "Descricao": "Caderno 1/4 profissional 72 folhas 45812 - Oxford",
        "Estoques": [
          {
            "CodigoFilial": "09",
            "Quantidade": 100.0,
            "QuantidadeReservada": 1.0,
            "QuantidadePedida": 1.0,
            "QuantidadeDisponivel": 99.0,
            "QuantidadeDiferenca": -98.0,
            "QuantidadePedidoFornecedor": 1.0
          },
          {
            "CodigoFilial": "01",
            "Quantidade": 100.0,
            "QuantidadeReservada": 32.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 68.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 1.0
          },
          {
            "CodigoFilial": "02",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "03",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "04",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 6.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259694.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "05",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "06",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "07",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "08",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "98",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "99",
            "Quantidade": 0.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 0.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          }
        ],
        "UserMessage": null
      },
      "DesativaRegimeEspecial": null,
      "BloquearRegimeEspecial": false,
      "DesativaRegimeEspecialAntes": null,
      "PendenciaDescontoSobreOferta": false,
      "UserMessage": null,
      "ServicoAgregado": false
    },
    {
      "AdquirirQuantidadeTotal": false,
      "ProdutoEncomendaComprarTotal": false,
      "AliquotaIpi": 0.0,
      "Ambiente": "",
      "Carga": "A",
      "Classe": "Itempedidovenda",
      "Codigo": "93969",
      "CodigoCorTinta": "0",
      "CodigoFilialReserva": "09",
      "CodigoFilialRetirada": "FR 02",
      "CodigoFilialTransferencia": "FT 02",
      "CodigoItemOrcamento": 0,
      "CodigoProduto": "93969",
      "CodigoTinta": 0,
      "CodigoTipoEntrega": "F",
      "ControleLote": false,
      "Cor": "#000000",
      "DataMarcadaEntrega": null,
      "DataPrevisaoEntrega": "2022-05-07T00:00:00",
      "DescontoMaximo": 0.0,
      "DescontoPendente": false,
      "PrecoAlteradoManualmente": false,
      "DescricaoProduto": "CADERNO 1/4 PROFISSIONAL 80 FLS - REF 1712 - OXFORD",
      "DespesasInclusas": false,
      "EncomendaAutomatica": false,
      "EntregaPosterior": 0,
      "Identificador": 3492615,
      "Index": 3,
      "Lote": "",
      "MenorFracaoVenda": 1.0,
      "NfDevolucao": "",
      "PedidoCompraCliente": 3,
      "Pendencia": "",
      "PercentualDesconto": 0.0,
      "PermiteAlterarPreco": true,
      "Peso": 0.33,
      "PrecoProduto": 26.9,
      "PrecoTinta": 0.0,
      "PrecoTotalAVista": 26.9,
      "PrecoTotalTabela": 26.9,
      "PrecoAVista": 26.9,
      "PrecoUnitarioAVista": 26.9,
      "PrecoUnitarioTabela": 26.9,
      "Quantidade": 1.0,
      "QuantidadeFormatada": null,
      "QuantidadeDevolvida": 0.0,
      "QuantidadeEstoque": 98.0,
      "QuantidadeReservada": 0.0,
      "TipoFaturamento": null,
      "TipoVendaSobEncomenda": 0,
      "TurnoEntrega": null,
      "Unidade": "PC",
      "ValorDesconto": 0.0,
      "ValorIpi": 0.0,
      "ValorSubstituicao": 0.0,
      "ValorTotal": 26.9,
      "VendaSobEncomenda": false,
      "Volume": 1,
      "PendenciaLocalRetirada": false,
      "IdClienteCentroCusto": 0,
      "NomeCentroCusto": "",
      "PedidoCompra": "pedido compra C",
      "PercentualMarkUp": 21.3,
      "MarkUpAbaixoDoPermitido": false,
      "MarkupMinimo": 20.0,
      "PrecoVendaMinimoCustoReal": 22.9519714285714,
      "OrdemItem": 3,
      "ListEstoqueProduto": {
        "Codigo": "93969",
        "CodigoProduto": "93969",
        "Descricao": "CADERNO 1/4 PROFISSIONAL 80 FLS - REF 1712 - OXFORD",
        "Estoques": [
          {
            "CodigoFilial": "09",
            "Quantidade": 100.0,
            "QuantidadeReservada": 2.0,
            "QuantidadePedida": 1.0,
            "QuantidadeDisponivel": 98.0,
            "QuantidadeDiferenca": -97.0,
            "QuantidadePedidoFornecedor": 2.0
          },
          {
            "CodigoFilial": "01",
            "Quantidade": 100.0,
            "QuantidadeReservada": 11.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 89.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 1.0
          },
          {
            "CodigoFilial": "02",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "03",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "04",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "05",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "06",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "07",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "08",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "98",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "99",
            "Quantidade": 0.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 0.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          }
        ],
        "UserMessage": null
      },
      "DesativaRegimeEspecial": null,
      "BloquearRegimeEspecial": false,
      "DesativaRegimeEspecialAntes": null,
      "PendenciaDescontoSobreOferta": false,
      "UserMessage": null,
      "ServicoAgregado": false
    },
    {
      "AdquirirQuantidadeTotal": false,
      "ProdutoEncomendaComprarTotal": false,
      "AliquotaIpi": 0.0,
      "Ambiente": "",
      "Carga": "A",
      "Classe": "Itempedidovenda",
      "Codigo": "93955",
      "CodigoCorTinta": "0",
      "CodigoFilialReserva": "09",
      "CodigoFilialRetirada": "FR 03",
      "CodigoFilialTransferencia": "FT 03",
      "CodigoItemOrcamento": 0,
      "CodigoProduto": "93955",
      "CodigoTinta": 0,
      "CodigoTipoEntrega": "F",
      "ControleLote": false,
      "Cor": "#000000",
      "DataMarcadaEntrega": null,
      "DataPrevisaoEntrega": "2022-05-07T00:00:00",
      "DescontoMaximo": 0.0,
      "DescontoPendente": false,
      "PrecoAlteradoManualmente": false,
      "DescricaoProduto": "CADERNO 1/4 PROFISSIONAL 90 FLS - REF 2403 - OXFORD",
      "DespesasInclusas": false,
      "EncomendaAutomatica": false,
      "EntregaPosterior": 0,
      "Identificador": 2616816,
      "Index": 4,
      "Lote": "",
      "MenorFracaoVenda": 1.0,
      "NfDevolucao": "",
      "PedidoCompraCliente": 4,
      "Pendencia": "",
      "PercentualDesconto": 0.0,
      "PermiteAlterarPreco": true,
      "Peso": 0.32,
      "PrecoProduto": 17.95,
      "PrecoTinta": 0.0,
      "PrecoTotalAVista": 17.95,
      "PrecoTotalTabela": 17.95,
      "PrecoAVista": 17.95,
      "PrecoUnitarioAVista": 17.95,
      "PrecoUnitarioTabela": 17.95,
      "Quantidade": 1.0,
      "QuantidadeFormatada": null,
      "QuantidadeDevolvida": 0.0,
      "QuantidadeEstoque": 98.0,
      "QuantidadeReservada": 0.0,
      "TipoFaturamento": null,
      "TipoVendaSobEncomenda": 0,
      "TurnoEntrega": null,
      "Unidade": "PC",
      "ValorDesconto": 0.0,
      "ValorIpi": 0.0,
      "ValorSubstituicao": 0.0,
      "ValorTotal": 17.95,
      "VendaSobEncomenda": false,
      "Volume": 1,
      "PendenciaLocalRetirada": false,
      "IdClienteCentroCusto": 0,
      "NomeCentroCusto": "",
      "PedidoCompra": "pedido compra D",
      "PercentualMarkUp": 30.64,
      "MarkUpAbaixoDoPermitido": false,
      "MarkupMinimo": 20.0,
      "PrecoVendaMinimoCustoReal": 12.28744897959184,
      "OrdemItem": 4,
      "ListEstoqueProduto": {
        "Codigo": "93955",
        "CodigoProduto": "93955",
        "Descricao": "CADERNO 1/4 PROFISSIONAL 90 FLS - REF 2403 - OXFORD",
        "Estoques": [
          {
            "CodigoFilial": "09",
            "Quantidade": 100.0,
            "QuantidadeReservada": 2.0,
            "QuantidadePedida": 1.0,
            "QuantidadeDisponivel": 98.0,
            "QuantidadeDiferenca": -97.0,
            "QuantidadePedidoFornecedor": 2.0
          },
          {
            "CodigoFilial": "01",
            "Quantidade": 100.0,
            "QuantidadeReservada": 12.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 88.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 1.0
          },
          {
            "CodigoFilial": "02",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "03",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "04",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "05",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "06",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "07",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "08",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "98",
            "Quantidade": 259700.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 259700.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          },
          {
            "CodigoFilial": "99",
            "Quantidade": 0.0,
            "QuantidadeReservada": 0.0,
            "QuantidadePedida": 0.0,
            "QuantidadeDisponivel": 0.0,
            "QuantidadeDiferenca": null,
            "QuantidadePedidoFornecedor": 0.0
          }
        ],
        "UserMessage": null
      },
      "DesativaRegimeEspecial": null,
      "BloquearRegimeEspecial": false,
      "DesativaRegimeEspecialAntes": null,
      "PendenciaDescontoSobreOferta": false,
      "UserMessage": null,
      "ServicoAgregado": false
    }
  ],
  "QuantidadeItens": 4,
  "PesoTotal": 1.415,
  "MarkupTotal": 39.97,
  "OcultarRetiradaOutroLocal": false,
  "TipoOrcamentoDescricao": null,
  "UserMessage": null
}